module.exports = __webpack_public_path__ + "img/features-1.c65d737a.png";